import {
  type CreatedSurveyFragment,
  EngagementCreateSurveyDocument,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'

import { SurveyWizard } from 'modules/engagement_surveys/components/SurveyWizard'

interface Props {
  onClose: () => void
  onSuccess: (survey: CreatedSurveyFragment) => void
}

export function CreateSurveyWizard({ onClose, onSuccess }: Props) {
  const { company } = useCurrentSession()

  const [createSurvey] = useMutation(EngagementCreateSurveyDocument, {
    extractorFn: (data) => data.surveysMutations.createSurveysSurvey,
  })

  return (
    <SurveyWizard
      title={i18n.t('surveys.create_survey_wizard.title')}
      onClose={onClose}
      onSubmit={async (formData) => {
        const result = await createSurvey({
          variables: {
            companyId: company?.id,
            title: formData.title,
            anonymous: formData.anonymous,
            description: formData.description,
            editorIds: formData.editors.map((editor) => editor.id),
            respondentStrategy: formData.respondentStrategy,
            restrictedViewersEnabled: formData.restrictedViewersEnabled,
          },
        })

        const handled = handleResult(result, () => null)

        if (handled.success && handled.data?.survey) {
          onSuccess(handled.data.survey)
        }
      }}
    />
  )
}
